import { IconLogout } from '@tabler/icons-react';

import { Screen } from '../../components';
import { logout } from '../../services/user';

import './UnauthorizedScreen.scss';

import Logo from '../../assets/cf-logo.png';

const UnauthorizedScreen = () => {
  return (
    <Screen id="loading" sidebar={false}>
      <div className="content">
        <img alt="logo" src={Logo} />
        <p>Este dispositivo no está autorizado al uso de la plataforma.</p>
        <button
          type="button"
          onClick={logout}
          className="mt-6 inline-flex items-center gap-2 px-6 py-2.5 rounded-xl bg-white/10 hover:bg-red-900/30 text-white hover:text-red-300 transition-all duration-300 border border-white/20"
        >
          <IconLogout size={18} />
          <span className="font-medium">Cerrar sesión</span>
        </button>
      </div>
    </Screen>
  );
};

export { UnauthorizedScreen };
